export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00833.6d52ce8a.png";